export default {
    roles: {
        superAdmin: 1000,
        countryAdmin: 2000,
        retailerAdmin: 3000,
    },
};
